import { useNavigate } from "react-router-dom";
import { HeaderTitle } from "../../../../components/header/Header";
import Container from "../../../../components/layout/Container";
import NavigateGoBack from "../../../../functions/Navigate.Goback";
import {
  STYLE_MARGIN_TOP_PARENT,
  STYLE_PARENT_BUTTON_TWO,
  STYLE_PARENT_PADDING,
} from "../../../../utils/useStyle";
import { CardMain } from "../../../../components/card/CardMain";
import { ICON_INFO } from "../../../../utils/useIcons";
import {
  ButtonCounter,
  MTButton,
} from "../../../../components/button/MTButton";
import { CardTaxPremium } from "../../styles/Card/CardMenuPremium";
import {
  option_income_business_tax_40_3,
  option_income_business_tax_40_5,
  option_income_business_tax_40_7,
  option_income_business_tax_40_8,
  option_income_business_tax_40_8_asset,
} from "../../functions/options";
import { useState } from "react";
import { PayerIncomeInfo } from "./VIIncome_Freelance";
import { InfoDrawer } from "../../../../components/drawer/InfoDrawer";
import DetailCost from "./DetailCost/DetailCost";
import { useTaxStore } from "../../../../_store/taxplanStore";
import {
  AddOrder,
  DeleteOrder,
  Tax408PropertyPercent,
  TotalExpense,
  onChangeExpensTaxDetail,
  onChangeTax403,
  onChangeTax403Balance,
  onChangeTax405,
  onChangeTax405Balance,
  onChangeTax407,
  onChangeTax407Balance,
  onChangeTax408,
  onChangeTax408Balance,
  onChangeTax408_property,
  onChangeTax408_property_balance,
  tax405Percent,
} from "../../../../functions/taxFucntion/premium/businessFunction";
import _ from "lodash";
import { numberWithoutComma } from "../../../balance/component/VIDrawerDebt.Main";
import { useBalanceStore } from "../../../../_store/balanceStore";
import { PopupMain2 } from "../../../../components/popup/PopupMain";

const Income403Info = ({
  open403Info,
  setOpen403Info,
  text = "",
  head = "เงินได้ตามมาตรา 40(3)",
}) => {
  return (
    <InfoDrawer
      head={head}
      text={text}
      open={open403Info}
      onClose={() => {
        setOpen403Info(false);
      }}
    />
  );
};

const Income405Info = ({ open405Info, setOpen405Info }) => {
  return (
    <InfoDrawer
      head={"เงินได้ตามมาตรา 40(5)"}
      text={
        <div className=" mb-4">
          เงินหรือประโยชน์ที่ได้รับเนื่องจากการให้เช่าสินทรัพย์ เช่น ค่าเช่าบ้าน
          ค่าเช่ารถยนต์ การผิดสัญญาเช่าซื้อ หรือการผิดสัญญาซื้อขายเงินผ่อน
          เป็นต้น
        </div>
      }
      open={open405Info}
      onClose={() => {
        setOpen405Info(false);
      }}
    />
  );
};

const Income407Info = ({ open407Info, setOpen407Info, balanceData }) => {
  return (
    <InfoDrawer
      head={"เงินได้ตามมาตรา 40(7)"}
      text={
        <div className=" mb-4">
          เงินหรือประโยชน์ที่ได้รับเนื่องจากการให้เช่าสินทรัพย์ เช่น ค่าเช่าบ้าน
          ค่าเช่ารถยนต์ การผิดสัญญาเช่าซื้อ หรือการผิดสัญญาซื้อขายเงินผ่อน
          เป็นต้น
        </div>
      }
      open={open407Info}
      onClose={() => {
        setOpen407Info(false);
      }}
      balanceData={balanceData}
    />
  );
};

const Income408Info = ({ open408Info, setOpen408Info }) => {
  return (
    <InfoDrawer
      head={"เงินได้ตามมาตรา 40(8)"}
      text={
        <div className=" mb-4">
          เงินได้จากธุรกิจ การพาณิชย์ ฯลฯ เงินส่วนแบ่งกำไรจากกองทุนรวม
          (ก่อนวันที่ 20 สิงหาคม 2562)
          เงินได้จากการขายอสังหาริมทรัพย์อันเป็นมรดก
          หรือได้มาโดยมิได้มุ่งในทางการค้า เงินหรือผลประโยชน์ใดๆ
          ที่ได้รับเนื่องจากการขายหน่วยลงทุนคืนให้แก่กองทุนรวมเพื่อการเลี้ยงชีพตามกฎหมายว่าด้วยหลักทรัพย์และตลาดหลักทรัพย์
          ทั้งที่ได้รับยกเว้นภาษีเงินได้และที่ไม่ได้รับยกเว้นภาษีเงินได้
        </div>
      }
      open={open408Info}
      onClose={() => {
        setOpen408Info(false);
      }}
    />
  );
};

const Income408AssetInfo = ({ open408AssetInfo, setOpen408AssetInfo }) => {
  return (
    <InfoDrawer
      head={
        <div className=" text-xl">
          เงินได้จากการขายอสังหาริมทรัพย์
          ที่ได้มาโดยมิได้มุ่งในทางการค้าหรือหากำไรและเลือกเสียภาษีโดยไม่นำไปรวมคำนวณภาษีกับเงินได้อื่นๆ
        </div>
      }
      text={
        <div className="">
          เงินได้จากการขายอสังหาริมทรัพย์อันเป็นมรดกอสังหาริมทรัพย์ที่ได้รับจากการให้โดยเสน่หา
          หรืออสังหาริมทรัพย์ที่ได้มาโดยมิได้มุ่งในทางการค้าหรือหากำไร
          และเลือกเสียภาษีโดยไม่นำไปรวมคำนวณภาษีกับเงินได้อื่นๆ
          หากมีความประสงค์จะขอหักค่าใช้จ่ายตามความจำเป็น และสมควร
          ให้คำนวณภาษีที่ต้องชำระ
          โดยนำเงินได้จากการขายอสังหาริมทรัพย์หักค่าใช้จ่ายตามความจำเป็นและสมควร
          เหลือเป็นเงินได้สุทธิให้หารด้วยจำนวนปีที่ถือครอง
          ได้ผลลัพธ์เท่าใดให้คำนวณภาษีตามอัตราภาษีเงินได้บุคคลธรรมดา
          (ไม่ได้รับยกเว้น 150,000 บาท)
          ได้เท่าใดให้คูณด้วยจำนวนปีที่ถือครองผลลัพธ์เป็นภาษีที่ต้องชำระจำนวนภาษีดังกล่าวข้างต้นต้องไม่เกินร้อยละ
          20 ของราคาขาย
        </div>
      }
      open={open408AssetInfo}
      onClose={() => {
        setOpen408AssetInfo(false);
      }}
    />
  );
};

const ViewIncomeBusiness = () => {
  const navigate = useNavigate();
  const taxData = useTaxStore((state) => state.taxData);
  const setTaxData = useTaxStore((state) => state.setTaxData);

  const balanceData = useBalanceStore((state) => state.balanceData);
  const setBalanceData = useBalanceStore((state) => state.setBalanceData);

  const [openInfo, setOpenInfo] = useState(false);
  const [open403Info, setOpen403Info] = useState(false);
  const [open405Info, setOpen405Info] = useState(false);
  const [open407Info, setOpen407Info] = useState(false);
  const [open408Info, setOpen408Info] = useState(false);
  const [open408AssetInfo, setOpen408AssetInfo] = useState(false);
  const [openAllInData, setAllInData] = useState(false);

  const [popupError, setPopuperror] = useState({
    403: false,
    405: false,
    407: false,
    408: false,
    "408_property": false,
  });

  const [formTax, setFormTax] = useState({
    ...taxData,
    tax_403: taxData?.tax_403 ? taxData?.tax_403 : [],
    tax_405: taxData?.tax_405 ? taxData?.tax_405 : [],
    tax_407: taxData?.tax_407 ? taxData?.tax_407 : [],
    tax_408: taxData?.tax_408 ? taxData?.tax_408 : [],
    tax_408_property: taxData?.tax_408_property
      ? taxData?.tax_408_property
      : [],
  });

  const [formBalance, setFormBalance] = useState({ ...balanceData });

  // console.log("formBalance", formBalance);
  // console.log("tax_408", formTax?.tax_408);

  // console.log("tax403_expense_cost",formTax?.tax403_expense_cost)
  // console.log("tax403_expense_salary",formTax?.tax403_expense_salary)
  // console.log("tax403_expense_other",formTax?.tax403_expense_other)


  return (
    <div>
      <Container>
        <PopupMain2
          onClick={() => {
            setPopuperror((prev) => {
              return { ...prev, ["403"]: false };
            });
          }}
          open={popupError?.["403"]}
          text={
            <div className=" flex flex-col items-start w-full px-[20px] text-left text-sm ">
              <p>
                ท่านบันทึก จำนวนเงินรวมในรายการค่าใช้จ่ายจริง ของผู้มีเงินได้
                ไม่เท่ากับค่าใช้จ่ายจริง โปรดตรวจสอบ ค่าลิขสิทธิ์
                ค่าสิทธิ์ในสินทรัพย์ทางปัญญา (Royalty) และ ค่ากู๊ดวิลล์
                (Goodwill) หรือ เงินได้รายปีที่ได้ มาจากนิติกรรม
                และคำพิพากษาของศาล (มาตรา 40(3))
              </p>
            </div>
          }
        />
        <PopupMain2
          onClick={() => {
            setPopuperror((prev) => {
              return { ...prev, ["405"]: false };
            });
          }}
          open={popupError?.["405"]}
          text={
            <div className=" flex flex-col items-start w-full px-[20px] text-left text-sm ">
              <p>
                ท่านบันทึก จำนวนเงินรวมในรายการค่าใช้จ่ายจริง ของผู้มีเงินได้
                ไม่เท่ากับค่าใช้จ่ายจริง โปรดตรวจสอบ ค่าเช่า
                ค่าผิดสัญญาเช่าซื้อหรือซื้อขายเงินผ่อน (มาตรา 40(5))
              </p>
            </div>
          }
        />
        <PopupMain2
          onClick={() => {
            setPopuperror((prev) => {
              return { ...prev, ["407"]: false };
            });
          }}
          open={popupError?.["407"]}
          text={
            <div className=" flex flex-col items-start w-full px-[20px] text-left text-sm ">
              <p>
                ท่านบันทึก จำนวนเงินรวมในรายการค่าใช้จ่ายจริง ของผู้มีเงินได้
                ไม่เท่ากับค่าใช้จ่ายจริง โปรดตรวจสอบ ค่าเช่า
                เงินได้จากการรับเหมาที่ผู้รับเหมาทั้งค่าแรง และค่าของ
                ที่ต้องลงทุนด้วยการจัดหาสัมภาระ ในส่วนสำคัญ นอกจากเครื่องมือ
                (มาตรา 40(7))
              </p>
            </div>
          }
        />
        <PopupMain2
          onClick={() => {
            setPopuperror((prev) => {
              return { ...prev, ["408"]: false };
            });
          }}
          open={popupError?.["408"]}
          text={
            <div className=" flex flex-col items-start w-full px-[20px] text-left text-sm ">
              <p>
                ท่านบันทึก จำนวนเงินรวมในรายการค่าใช้จ่ายจริง ของผู้มีเงินได้
                ไม่เท่ากับค่าใช้จ่ายจริง โปรดตรวจสอบ เงินได้จากธุรกิจ การพาณิชย์
                การเกษตร การอุตสาหกรรม การขนส่ง และเงินได้อื่นๆ (มาตรา 40(8))
              </p>
            </div>
          }
        />
        {/* <PopupMain2
          onClick={() => {
            setPopuperror((prev) => {
              return { ...prev, ["408_property"]: false };
            });
          }}
          open={popupError?.["408_property"]}
          text={
            <div className=" flex flex-col items-start w-full px-[20px] text-left text-sm ">
              <p>
                ท่านบันทึก จำนวนเงินรวมในรายการค่าใช้จ่ายจริง ของผู้มีเงินได้
                ไม่เท่ากับค่าใช้จ่ายจริง โปรดตรวจสอบ เงินได้จากการขายอสังหาริมทรัพย์ฯ (มาตรา 40(8))
              </p>
            </div>
          }
        /> */}
        <div className={STYLE_MARGIN_TOP_PARENT}>
          <HeaderTitle
            title=" รายรับจากสินทรัพย์, การทำธุรกิจ "
            isGoback
            onClickGoBack={() => {
              NavigateGoBack(navigate);
              setTaxData({ ...formTax });
            }}
          />
          <div className={STYLE_PARENT_PADDING}>
            {/* ------ 40(3) ------ */}
            <CardMain
              marginyellow=" mt-14 "
              title={
                <div className=" pt-12 pr-3 flex">
                  ค่าลิขสิทธิ์ ค่าสิทธิ์ในสินทรัพย์ทางปัญญา (Royalty) และ
                  ค่ากู๊ดวิลล์ (Goodwill) หรือ เงินได้รายปีที่ได้ มาจากนิติกรรม
                  และคำพิพากษาของศาล (มาตรา 40(3))
                  <ICON_INFO
                    className={` w-4 h-4 text-gray-900 flex-none`}
                    onClick={() => {
                      setOpen403Info(true);
                    }}
                  />
                </div>
              }
              panel={
                <>
                  <div className=" px-3 -mt-3 space-y-[15px]">
                    <div className=" bg-white rounded-full px-4 py-[6px] flex justify-between items-center h-9 ">
                      <div className=" text-sm text-black font-medium">
                        เพิ่มรายการ
                      </div>
                      <ButtonCounter
                        handleNext={() => {
                          AddOrder("tax_403", formTax, setFormTax);
                        }}
                        value={formTax?.tax_403?.length}
                      />
                    </div>
                    {formTax?.tax_403?.map((data, index) => {
                      return (
                        <CardTaxPremium
                          index={index}
                          data={data}
                          ishasCal={
                            data?.type_job?.value !== " tax_income_annual"
                          }
                          isHasAllInInfo={true}
                          options={option_income_business_tax_40_3}
                          expressTitle="วิธีการหักค่าใช้จ่าย"
                          allIn_percent={"50"}
                          onChangeFreeJob={(value, field, index) => {
                            onChangeTax403(
                              value,
                              field,
                              index,
                              formTax,
                              setFormTax
                            );
                          }}
                          openAllInData={() => {
                            setAllInData(true);
                          }}
                          openInfo={() => {
                            setOpenInfo(true);
                          }}
                          DeleteOrder={(a) => {
                            DeleteOrder(a, formTax, setFormTax, "tax_403");
                          }}
                        />
                      );
                    })}
                    {formBalance?.other_income_list?.map((item, index) => {
                      if (item?.option_income_other !== "copy_right") {
                        return <></>;
                      }

                      return (
                        <CardTaxPremium
                          key={index}
                          index={index}
                          data={item}
                          ishasCal={
                            item?.type_job?.value !== "tax_income_annual"
                          }
                          isHasAllInInfo={true}
                          options={option_income_business_tax_40_3}
                          expressTitle="วิธีการหักค่าใช้จ่าย"
                          allIn_percent={"50"}
                          onChangeFreeJob={(value, field, index) => {
                            onChangeTax403Balance(
                              value,
                              field,
                              index,
                              formBalance,
                              setFormBalance
                            );
                          }}
                          openAllInData={() => {
                            setAllInData(true);
                          }}
                          openInfo={() => {
                            setOpenInfo(true);
                          }}
                          disableTitle1={true}
                          disableDelete={true}
                          isDisableWithholdingTax={true}
                        />
                      );
                    })}
                  </div>
                  {(formTax?.tax_403
                    ?.map((item) => item?.calculating_method)
                    .some((item) => item === "หักตามจริง") ||
                    formBalance?.other_income_list
                      ?.filter(
                        (item) => item?.option_income_other === "copy_right"
                      )
                      ?.map((item) => item?.calculating_method)
                      .some((item) => item === "หักตามจริง")) && (
                    <div className="px-3 mt-[15px]">
                      <DetailCost
                        data={formTax?.tax_403}
                        TotalExpense={
                          Number(
                            formTax?.tax_403
                              ?.filter((item) => {
                                return (
                                  item?.calculating_method === "หักตามจริง"
                                );
                              })
                              ?.reduce((total, num) => {
                                return total + Number(num?.Tax_Real || 0);
                              }, 0) || 0
                          ) +
                          Number(
                            formBalance?.other_income_list
                              ?.filter((item) => {
                                return (
                                  item?.calculating_method === "หักตามจริง" &&
                                  item?.option_income_other === "copy_right"
                                );
                              })
                              ?.reduce((total, item) => {
                                return total + Number(item?.Tax_Real || 0);
                              }, 0) || 0
                          )
                        }
                        onChangeExpenstaxeDetail={(value, field) => {
                          onChangeExpensTaxDetail(
                            numberWithoutComma(value),
                            field,
                            setFormTax
                          );
                        }}
                        cost={{
                          cost: Number(formTax?.tax403_expense_cost || 0),
                          salary: Number(formTax?.tax403_expense_salary || 0),
                          others: Number(formTax?.tax403_expense_other || 0),
                        }}
                        field={{
                          service: "tax403_expense_cost",
                          salary: "tax403_expense_salary",
                          others: "tax403_expense_other",
                        }}
                        sum={
                          _.get(formTax, "tax403_expense_cost", 0) +
                          _.get(formTax, "tax403_expense_salary", 0) +
                          _.get(formTax, "tax403_expense_other", 0)
                        }
                      />
                    </div>
                  )}
                </>
              }
            />
            {/* ------ 40(5) ------ */}
            <CardMain
              marginyellow=" mt-4"
              title={
                <div className=" pt-4 pr-3 flex">
                  ค่าเช่า ค่าผิดสัญญาเช่าซื้อหรือซื้อขายเงินผ่อน (มาตรา 40(5))
                  <ICON_INFO
                    className={` w-4 h-4 text-gray-900 flex-none`}
                    onClick={() => {
                      setOpen405Info(true);
                    }}
                  />
                </div>
              }
              panel={
                <>
                  <div className=" px-3 -mt-3 space-y-[15px]">
                    <div className=" bg-white rounded-full px-4 py-[6px] flex justify-between items-center h-9 ">
                      <div className=" text-sm text-black font-medium">
                        เพิ่มรายการ
                      </div>
                      <ButtonCounter
                        handleNext={() => {
                          AddOrder("tax_405", formTax, setFormTax);
                        }}
                        value={formTax?.tax_405?.length}
                      />
                    </div>
                    {formTax?.tax_405?.map((data, index) => {
                      return (
                        <CardTaxPremium
                          expressTitle="วิธีการหักค่าใช้จ่าย"
                          options={option_income_business_tax_40_5}
                          openInfo={() => {
                            setOpenInfo(true);
                          }}
                          index={index}
                          data={data}
                          allIn_percent={String(
                            tax405Percent.find(
                              (item) => item?.label === data?.type_job?.label
                            )?.value || "-"
                          )}
                          ishasCal={
                            data?.type_job?.label !==
                            "การผิดสัญญาเช่าซื้อสินทรัพย์/ซื้อขายเงินผ่อน"
                          }
                          onChangeFreeJob={(value, field, index) => {
                            onChangeTax405(
                              value,
                              field,
                              index,
                              formTax,
                              setFormTax
                            );
                          }}
                          DeleteOrder={(a) => {
                            DeleteOrder(a, formTax, setFormTax, "tax_405");
                          }}
                        />
                      );
                    })}
                    {formBalance?.other_income_list?.map((item, index) => {
                      if (
                        item?.option_income_other !== "other_rent_nonviolence"
                      ) {
                        return <></>;
                      }

                      return (
                        <CardTaxPremium
                          key={index}
                          index={index}
                          data={item}
                          allIn_percent={String(
                            tax405Percent.find(
                              (item2) => item2?.label === item?.type_job?.label
                            )?.value || "-"
                          )}
                          ishasCal={
                            item?.type_job?.label !==
                            "การผิดสัญญาเช่าซื้อสินทรัพย์/ซื้อขายเงินผ่อน"
                          }
                          isHasAllInInfo={true}
                          options={option_income_business_tax_40_5}
                          expressTitle="วิธีการหักค่าใช้จ่าย"
                          onChangeFreeJob={(value, field, index) => {
                            onChangeTax405Balance(
                              value,
                              field,
                              index,
                              formBalance,
                              setFormBalance
                            );
                          }}
                          openAllInData={() => {
                            setAllInData(true);
                          }}
                          openInfo={() => {
                            setOpenInfo(true);
                          }}
                          disableTitle1={true}
                          disableDelete={true}
                          isDisableWithholdingTax={true}
                        />
                      );
                    })}
                    {(formTax?.tax_405
                      ?.map((item) => item?.calculating_method)
                      .some((item) => item === "หักตามจริง") ||
                      formBalance?.other_income_list
                        ?.filter(
                          (item) =>
                            item?.option_income_other ===
                            "other_rent_nonviolence"
                        )
                        ?.map((item) => item?.calculating_method)
                        .some((item) => item === "หักตามจริง")) && (
                      <div className="px-3 mt-[15px]">
                        <DetailCost
                          data={formTax?.tax_405}
                          TotalExpense={
                            Number(
                              formTax?.tax_405
                                ?.filter((item) => {
                                  return (
                                    item?.calculating_method === "หักตามจริง"
                                  );
                                })
                                ?.reduce((total, num) => {
                                  return total + Number(num?.Tax_Real || 0);
                                }, 0) || 0
                            ) +
                            Number(
                              formBalance?.other_income_list
                                ?.filter((item) => {
                                  return (
                                    item?.calculating_method === "หักตามจริง" &&
                                    item?.option_income_other ===
                                      "other_rent_nonviolence"
                                  );
                                })
                                ?.reduce((total, item) => {
                                  return total + Number(item?.Tax_Real || 0);
                                }, 0)
                            )
                          }
                          onChangeExpenstaxeDetail={(value, field) => {
                            onChangeExpensTaxDetail(
                              numberWithoutComma(value),
                              field,
                              setFormTax
                            );
                          }}
                          cost={{
                            cost: Number(formTax?.tax405_expense_cost),
                            salary: Number(formTax?.tax405_expense_salary),
                            others: Number(formTax?.tax405_expense_other),
                          }}
                          field={{
                            service: "tax405_expense_cost",
                            salary: "tax405_expense_salary",
                            others: "tax405_expense_other",
                          }}
                          sum={
                            Number(formTax?.tax405_expense_cost || 0) +
                            Number(formTax?.tax405_expense_salary || 0) +
                            Number(formTax?.tax405_expense_other || 0)
                          }
                        />
                      </div>
                    )}
                  </div>
                </>
              }
            />

            {/* ------ 40(7) ------ */}
            <CardMain
              marginyellow=" mt-14"
              title={
                <div className=" pt-12 pr-3 flex">
                  เงินได้จากการรับเหมาที่ผู้รับเหมาทั้งค่าแรง และค่าของ
                  ที่ต้องลงทุนด้วยการจัดหาสัมภาระ ในส่วนสำคัญ นอกจากเครื่องมือ
                  (มาตรา 40(7))
                  <ICON_INFO
                    className={` w-4 h-4 text-gray-900 flex-none`}
                    onClick={() => {
                      setOpen407Info(true);
                    }}
                  />
                </div>
              }
              panel={
                <div className=" px-3 -mt-3 space-y-[15px]">
                  <div className=" bg-white rounded-full px-4 py-[6px] flex justify-between items-center h-9 ">
                    <div className=" text-sm text-black font-medium">
                      เพิ่มรายการ
                    </div>
                    <ButtonCounter
                      handleNext={() => {
                        AddOrder("tax_407", formTax, setFormTax);
                      }}
                      value={formTax?.tax_407?.length}
                    />
                  </div>
                  {formTax?.tax_407?.map((data, index) => {
                    return (
                      <CardTaxPremium
                        index={index}
                        options={option_income_business_tax_40_7}
                        expressTitle="วิธีการหักค่าใช้จ่าย"
                        openInfo={() => {
                          setOpenInfo(true);
                        }}
                        data={data}
                        // ishasCal={
                        //   data?.type_job?.value !== " tax_income_annual"
                        // }
                        allIn_percent={60}
                        onChangeFreeJob={(value, field, index) => {
                          onChangeTax407(
                            value,
                            field,
                            index,
                            formTax,
                            setFormTax
                          );
                        }}
                        DeleteOrder={(a) => {
                          DeleteOrder(a, formTax, setFormTax, "tax_407");
                        }}
                      />
                    );
                  })}
                  {formBalance?.other_income_list?.map((item, index) => {
                    if (item?.option_income_other !== "contract_business") {
                      return <></>;
                    }

                    return (
                      <CardTaxPremium
                        key={index}
                        index={index}
                        options={option_income_business_tax_40_7}
                        expressTitle="วิธีการหักค่าใช้จ่าย"
                        openInfo={() => {
                          setOpenInfo(true);
                        }}
                        data={item}
                        disableTitle1={true}
                        isDisableWithholdingTax={true}
                        disableDelete={true}
                        ishasCal={
                          item?.type_job?.value !== " tax_income_annual"
                        }
                        allIn_percent={60}
                        onChangeFreeJob={(value, field, index) => {
                          onChangeTax407Balance(
                            value,
                            field,
                            index,
                            formBalance,
                            setFormBalance
                          );
                        }}
                      />
                    );
                  })}
                  {(formTax?.tax_407
                    ?.map((item) => item?.calculating_method)
                    .some((item) => item === "หักตามจริง") ||
                    formBalance?.other_income_list
                      ?.filter(
                        (item) =>
                          item?.option_income_other === "contract_business"
                      )
                      ?.map((item) => item?.calculating_method)
                      ?.some((item) => item === "หักตามจริง")) && (
                    <div className="px-3 mt-[15px]">
                      <DetailCost
                        data={formTax?.tax_407}
                        TotalExpense={
                          formTax?.tax_407
                            ?.filter((item) => {
                              return item?.calculating_method === "หักตามจริง";
                            })
                            ?.reduce((total, num) => {
                              return total + Number(num?.Tax_Real || 0);
                            }, 0) +
                          formBalance?.other_income_list
                            ?.filter(
                              (item) =>
                                item?.option_income_other ===
                                  "contract_business" &&
                                item?.calculating_method === "หักตามจริง"
                            )
                            ?.reduce((total, num) => {
                              return total + Number(num?.Tax_Real || 0);
                            }, 0)
                        }
                        onChangeExpenstaxeDetail={(value, field) => {
                          onChangeExpensTaxDetail(
                            numberWithoutComma(value),
                            field,
                            setFormTax
                          );
                        }}
                        cost={{
                          cost: formTax?.tax407_expense_cost,
                          salary: formTax?.tax407_expense_salary,
                          others: formTax?.tax407_expense_other,
                        }}
                        field={{
                          service: "tax407_expense_cost",
                          salary: "tax407_expense_salary",
                          others: "tax407_expense_other",
                        }}
                        sum={
                          _.get(formTax, "tax407_expense_cost", 0) +
                          _.get(formTax, "tax407_expense_salary", 0) +
                          _.get(formTax, "tax407_expense_other", 0)
                        }
                      />
                    </div>
                  )}
                </div>
              }
            />

            {/* ------ 40(8) ------ */}
            <CardMain
              marginyellow=" mt-10"
              title={
                <div className=" pt-8 pr-3 flex">
                  เงินได้จากธุรกิจ การพาณิชย์ การเกษตร การอุตสาหกรรม การขนส่ง
                  และเงินได้อื่นๆ (มาตรา 40(8))
                  <ICON_INFO
                    className={` w-4 h-4 text-gray-900 flex-none`}
                    onClick={() => {
                      setOpen408Info(true);
                    }}
                  />
                </div>
              }
              panel={
                <div className=" px-3 -mt-3 space-y-[15px]">
                  <div className=" bg-white rounded-full px-4 py-[6px] flex justify-between items-center h-9 ">
                    <div className=" text-sm text-black font-medium">
                      เพิ่มรายการ
                    </div>
                    <ButtonCounter
                      handleNext={() => {
                        AddOrder("tax_408", formTax, setFormTax);
                      }}
                      value={formTax?.tax_408?.length}
                    />
                  </div>
                  {formTax?.tax_408?.map((data, index) => {
                    return (
                      <CardTaxPremium
                        index={index}
                        options={option_income_business_tax_40_8}
                        value_dropdown={data?.type_job}
                        optionsGroup={true}
                        expressTitle="วิธีการหักค่าใช้จ่าย"
                        openInfo={() => {
                          setOpenInfo(true);
                        }}
                        data={data}
                        ishasCal={
                          data?.type_job?.label !==
                          "เงินส่วนแบ่งของกำไรจากกองทุนรวมตามประกาศคณะปฏิวัติฯ"
                        }
                        allIn_percent={data?.type_job === "" ? 0 : 60}
                        onChangeFreeJob={(value, field, index) => {
                          onChangeTax408(
                            value,
                            field,
                            index,
                            formTax,
                            setFormTax
                          );
                        }}
                        isActive={data?.type_job?.label !== "เงินได้อื่นๆ"}
                        DisableAllIn={data?.type_job?.label === "เงินได้อื่นๆ"}
                        DeleteOrder={(a) => {
                          DeleteOrder(a, formTax, setFormTax, "tax_408");
                        }}
                      />
                    );
                  })}
                  {formBalance?.other_income_list?.map((data, index) => {
                    if (data?.option_income_other !== "other_income_other") {
                      return <></>;
                    }

                    return (
                      <CardTaxPremium
                        index={index}
                        options={option_income_business_tax_40_8}
                        value_dropdown={data?.type_job}
                        optionsGroup={true}
                        expressTitle="วิธีการหักค่าใช้จ่าย"
                        openInfo={() => {
                          setOpenInfo(true);
                        }}
                        data={data}
                        ishasCal={
                          data?.type_job?.label !==
                          "เงินส่วนแบ่งของกำไรจากกองทุนรวมตามประกาศคณะปฏิวัติฯ"
                        }
                        allIn_percent={data?.type_job === "" ? 0 : 60}
                        onChangeFreeJob={(value, field, index) => {
                          onChangeTax408Balance(
                            value,
                            field,
                            index,
                            formBalance,
                            setFormBalance
                          );
                        }}
                        isActive={data?.type_job?.label !== "เงินได้อื่นๆ"}
                        DisableAllIn={data?.type_job?.label === "เงินได้อื่นๆ"}
                        disableTitle1={true}
                        disableDelete={true}
                        isDisableWithholdingTax={true}
                      />
                    );
                  })}

                  {(formTax?.tax_408
                    ?.map((item) => item?.calculating_method)
                    .some((item) => item === "หักตามจริง") ||
                    formBalance?.other_income_list
                      ?.filter(
                        (item) =>
                          item?.option_income_other === "other_income_other"
                      )
                      ?.map((item) => item?.calculating_method)
                      ?.some((item) => item === "หักตามจริง")) && (
                    <div className="px-3 mt-[15px]">
                      <DetailCost
                        data={formTax?.tax_408}
                        TotalExpense={
                          formTax?.tax_408
                            ?.filter((item) => {
                              return item?.calculating_method === "หักตามจริง";
                            })
                            ?.reduce((total, num) => {
                              return total + Number(num?.Tax_Real || 0);
                            }, 0) +
                          formBalance?.other_income_list
                            ?.filter(
                              (item) =>
                                item?.option_income_other ===
                                  "other_income_other" &&
                                item?.calculating_method === "หักตามจริง"
                            )
                            ?.reduce((total, num) => {
                              return total + Number(num?.Tax_Real || 0);
                            }, 0)
                        }
                        onChangeExpenstaxeDetail={(value, field) => {
                          onChangeExpensTaxDetail(
                            numberWithoutComma(value),
                            field,
                            setFormTax
                          );
                        }}
                        cost={{
                          cost: formTax?.tax408_expense_cost,
                          salary: formTax?.tax408_expense_salary,
                          others: formTax?.tax408_expense_other,
                        }}
                        field={{
                          service: "tax408_expense_cost",
                          salary: "tax408_expense_salary",
                          others: "tax408_expense_other",
                        }}
                        sum={
                          _.get(formTax, "tax408_expense_cost", 0) +
                          _.get(formTax, "tax408_expense_salary", 0) +
                          _.get(formTax, "tax408_expense_other", 0)
                        }
                      />
                    </div>
                  )}
                </div>
              }
            />
            {/* ------ 40(8) อสังหา------ */}
            <CardMain
              marginyellow=" mt-10"
              title={
                <div className=" pt-8 pr-3 flex">
                  เงินได้จากการขายอสังหาริมทรัพย์ฯ (มาตรา 40(8))
                  <ICON_INFO
                    className={` w-4 h-4 text-gray-900 flex-none`}
                    onClick={() => {
                      setOpen408AssetInfo(true);
                    }}
                  />
                </div>
              }
              panel={
                <div className=" px-3 -mt-3 space-y-[15px]">
                  <div className=" bg-white rounded-full px-4 py-[6px] flex justify-between items-center h-9 ">
                    <div className=" text-sm text-black font-medium">
                      เพิ่มรายการ
                    </div>
                    <ButtonCounter
                      handleNext={() => {
                        AddOrder("tax_408_property", formTax, setFormTax);
                      }}
                      value={formTax?.tax_408_property?.length}
                    />
                  </div>
                  {formTax?.tax_408_property?.map((data, index) => {
                    // console.log("data?.type_job?.label",data?.type_job?.label)
                    return (
                      <CardTaxPremium
                        index={index}
                        expressTitle="วิธีการหักค่าใช้จ่าย"
                        claculateMethodTitle="การคำนวณภาษี"
                        options={option_income_business_tax_40_8_asset}
                        isHasHoldingYear={
                          data?.type_job?.label ===
                          "การขายอสังหาริมทรัพย์ที่ได้มาโดยมิได้มุ่งในทางการค้าหรือหากำไร"
                        }
                        isSeparateCal={
                          data?.type_job?.label ===
                          "การขายอสังหาริมทรัพย์ที่ได้มาโดยมิได้มุ่งในทางการค้าหรือหากำไร"
                        }
                        openInfo={() => {
                          setOpenInfo(true);
                        }}
                        data={data}
                        ishasCal={
                          data?.type_job?.label !==
                          "เงินส่วนแบ่งของกำไรจากกองทุนรวมตามประกาศคณะปฏิวัติฯ"
                        }
                        DisableAllIn={data?.calculating_way === "แยกคำนวณ"}
                        DisableReal={
                          data?.type_job?.label !==
                          "การขายอสังหาริมทรัพย์ที่ได้มาโดยมิได้มุ่งในทางการค้าหรือหากำไร"
                        }
                        allIn_percent={
                          data?.type_job?.label ===
                          "การขายอสังหาริมทรัพย์ที่ได้มาโดยมิได้มุ่งในทางการค้าหรือหากำไร"
                            ? Tax408PropertyPercent(data?.tax_holding_year || 0)
                            : 50
                        }
                        onChangeFreeJob={(value, field, index) => {
                          onChangeTax408_property(
                            value,
                            field,
                            index,
                            formTax,
                            setFormTax
                          );
                        }}
                        DeleteOrder={(a) => {
                          DeleteOrder(
                            a,
                            formTax,
                            setFormTax,
                            "tax_408_property"
                          );
                        }}
                      />
                    );
                  })}
                  {formBalance?.other_income_list?.map((data, index) => {
                    if (data?.option_income_other !== "other_income_selling") {
                      return <></>;
                    }

                    return (
                      <CardTaxPremium
                        index={index}
                        expressTitle="วิธีการหักค่าใช้จ่าย"
                        claculateMethodTitle="การคำนวณภาษี"
                        options={option_income_business_tax_40_8_asset}
                        isHasHoldingYear={
                          data?.type_job?.label ===
                          "การขายอสังหาริมทรัพย์ที่ได้มาโดยมิได้มุ่งในทางการค้าหรือหากำไร"
                        }
                        isSeparateCal={
                          data?.type_job?.label ===
                          "การขายอสังหาริมทรัพย์ที่ได้มาโดยมิได้มุ่งในทางการค้าหรือหากำไร"
                        }
                        openInfo={() => {
                          setOpenInfo(true);
                        }}
                        data={data}
                        ishasCal={
                          data?.type_job?.label !==
                          "เงินส่วนแบ่งของกำไรจากกองทุนรวมตามประกาศคณะปฏิวัติฯ"
                        }
                        DisableAllIn={data?.calculating_way === "แยกคำนวณ"}
                        DisableReal={
                          data?.type_job?.label !==
                          "การขายอสังหาริมทรัพย์ที่ได้มาโดยมิได้มุ่งในทางการค้าหรือหากำไร"
                        }
                        allIn_percent={
                          data?.type_job?.label ===
                          "การขายอสังหาริมทรัพย์ที่ได้มาโดยมิได้มุ่งในทางการค้าหรือหากำไร"
                            ? Tax408PropertyPercent(data?.tax_holding_year || 0)
                            : 50
                        }
                        disableTitle1={true}
                        isDisableWithholdingTax={true}
                        onChangeFreeJob={(value, field, index) => {
                          onChangeTax408_property_balance(
                            value,
                            field,
                            index,
                            formBalance,
                            setFormBalance
                          );
                        }}
                        disableDelete={true}
                        //
                      />
                    );
                  })}
                </div>
              }
            />
          </div>
          <div className={STYLE_PARENT_BUTTON_TWO}>
            <MTButton
              text="ย้อนกลับ"
              color="bg-white"
              border="border border-maincyan"
              colortext="text-maincyan group-hover:text-white"
              hovercolor="hover:bg-maincyan group "
              width="w-full"
              onClick={() => {
                NavigateGoBack(navigate);
              }}
            />
            <MTButton
              text={"บันทึก"}
              color="bg-maincyan"
              width="w-full"
              onClick={() => {
                let sum403_expense =
                  Number(formTax?.tax403_expense_cost || 0) +
                  Number(formTax?.tax403_expense_salary || 0) +
                  Number(formTax?.tax403_expense_other || 0);

                let sum405_expense =
                  Number(formTax?.tax405_expense_cost || 0) +
                  Number(formTax?.tax405_expense_salary || 0) +
                  Number(formTax?.tax405_expense_other || 0);

                let sum407_expense =
                  Number(formTax?.tax407_expense_cost || 0) +
                  Number(formTax?.tax407_expense_salary || 0) +
                  Number(formTax?.tax407_expense_other || 0);

                let sum408_expense =
                  Number(formTax?.tax408_expense_cost || 0) +
                  Number(formTax?.tax408_expense_salary || 0) +
                  Number(formTax?.tax408_expense_other || 0);

                if (
                  formTax?.tax_403?.filter((item) => {
                    return item?.calculating_method === "หักตามจริง";
                  })?.length > 0 ||
                  formBalance?.other_income_list?.filter((item) => {
                    return (
                      item?.calculating_method === "หักตามจริง" &&
                      item?.option_income_other === "copy_right"
                    );
                  })?.length > 0
                ) {
                  if (
                    sum403_expense !==
                    Number(
                      formTax?.tax_403
                        ?.filter((item) => {
                          return item?.calculating_method === "หักตามจริง";
                        })
                        ?.reduce((total, num) => {
                          return total + Number(num?.Tax_Real || 0);
                        }, 0) || 0
                    ) +
                      Number(
                        formBalance?.other_income_list
                          ?.filter((item) => {
                            return (
                              item?.calculating_method === "หักตามจริง" &&
                              item?.option_income_other === "copy_right"
                            );
                          })
                          ?.reduce((total, item) => {
                            return total + Number(item?.Tax_Real || 0);
                          }, 0) || 0
                      )
                  ) {
                    setPopuperror((prev) => {
                      return { ...prev, ["403"]: true };
                    });
                    return;
                  }
                }

                if (
                  formTax?.tax_405?.filter((item) => {
                    return item?.calculating_method === "หักตามจริง";
                  })?.length > 0 ||
                  formBalance?.other_income_list?.filter((item) => {
                    return (
                      item?.calculating_method === "หักตามจริง" &&
                      item?.option_income_other === "other_rent_nonviolence"
                    );
                  })?.length > 0
                ) {
                  if (
                    sum405_expense !==
                    formTax?.tax_405
                      ?.filter((item) => {
                        return item?.calculating_method === "หักตามจริง";
                      })
                      ?.reduce((total, num) => {
                        return total + Number(num?.Tax_Real || 0);
                      }, 0) +
                      Number(
                        formBalance?.other_income_list
                          ?.filter((item) => {
                            return (
                              item?.calculating_method === "หักตามจริง" &&
                              item?.option_income_other ===
                                "other_rent_nonviolence"
                            );
                          })
                          ?.reduce((total, item) => {
                            return total + Number(item?.Tax_Real || 0);
                          }, 0) || 0
                      )
                  ) {
                    setPopuperror((prev) => {
                      return { ...prev, ["405"]: true };
                    });
                    return;
                  }
                }

                if (
                  formTax?.tax_407
                    ?.map((item) => item?.calculating_method)
                    .some((item) => item === "หักตามจริง") ||
                  formBalance?.other_income_list
                    ?.filter(
                      (item) =>
                        item?.option_income_other === "contract_business"
                    )
                    ?.map((item) => item?.calculating_method)
                    ?.some((item) => item === "หักตามจริง")
                ) {
                  if (
                    sum407_expense !==
                    formTax?.tax_407
                      ?.filter((item) => {
                        return item?.calculating_method === "หักตามจริง";
                      })
                      ?.reduce((total, num) => {
                        return total + Number(num?.Tax_Real || 0);
                      }, 0) +
                      formBalance?.other_income_list
                        ?.filter(
                          (item) =>
                            item?.option_income_other === "contract_business" &&
                            item?.calculating_method === "หักตามจริง"
                        )
                        ?.reduce((total, num) => {
                          return total + Number(num?.Tax_Real || 0);
                        }, 0)
                  ) {
                    setPopuperror((prev) => {
                      return { ...prev, ["407"]: true };
                    });
                    return;
                  }
                }

                if (
                  formTax?.tax_408
                    ?.map((item) => item?.calculating_method)
                    .some((item) => item === "หักตามจริง") ||
                  formBalance?.other_income_list
                    ?.filter(
                      (item) =>
                        item?.option_income_other === "other_income_other" &&
                        item?.calculating_method === "หักตามจริง"
                    )
                    ?.map((item) => item?.calculating_method)
                    ?.some((item) => item === "หักตามจริง")
                ) {
                  if (
                    sum408_expense !==
                    formTax?.tax_408
                      ?.filter((item) => {
                        return item?.calculating_method === "หักตามจริง";
                      })
                      ?.reduce((total, num) => {
                        return total + Number(num?.Tax_Real || 0);
                      }, 0) +
                      formBalance?.other_income_list
                        ?.filter(
                          (item) =>
                            item?.option_income_other ===
                              "other_income_other" &&
                            item?.calculating_method === "หักตามจริง"
                        )
                        ?.reduce((total, num) => {
                          return total + Number(num?.Tax_Real || 0);
                        }, 0)
                  ) {
                    setPopuperror((prev) => {
                      return { ...prev, ["408"]: true };
                    });
                    return;
                  }
                }

                setTaxData({ ...formTax });
                setBalanceData({ ...formBalance });
                NavigateGoBack(navigate);
              }}
            />
          </div>
        </div>
      </Container>
      {openInfo && (
        <PayerIncomeInfo openInfo={openInfo} setOpenInfo={setOpenInfo} />
      )}
      {/* openAllInData */}
      {openAllInData && (
        <Income403Info
          open403Info={openAllInData}
          setOpen403Info={setAllInData}
          head={"การหักค่าใช้จ่าย"}
          text={
            <div className=" mb-4">
              หักแบบเหมา 50% แต่ไม่เกิน ฿100,000 หรือหักตามจริง
            </div>
          }
        />
      )}
      {open403Info && (
        <Income403Info
          open403Info={open403Info}
          setOpen403Info={setOpen403Info}
          text={
            <div className=" mb-4">
              ค่าแห่งกู๊ดวิลล์ ค่าแห่งลิขสิทธิ หรือสิทธิอย่างอื่นในทำนอง
              เดียวกัน หรือเงินได้ที่มีลักษณะเป็นเงินได้รายปี
              เช่นค่าเขียน/ค่าพัฒนาโปรแกรมคอมพิวเตอร์
            </div>
          }
        />
      )}
      {open405Info && (
        <Income405Info
          open405Info={open405Info}
          setOpen405Info={setOpen405Info}
        />
      )}
      {open407Info && (
        <Income407Info
          open407Info={open407Info}
          setOpen407Info={setOpen407Info}
          balanceData={balanceData}
        />
      )}
      {open408Info && (
        <Income408Info
          open408Info={open408Info}
          setOpen408Info={setOpen408Info}
        />
      )}
      {open408AssetInfo && (
        <Income408AssetInfo
          open408AssetInfo={open408AssetInfo}
          setOpen408AssetInfo={setOpen408AssetInfo}
        />
      )}
    </div>
  );
};

export default ViewIncomeBusiness;
